export default {
  数据权限管理: '数据权限管理',
  '说明：': '说明：',
  '私有：登录人数据权限不同，看到的数据范围不同，上级部门的部门负责人可以 看到下级部门的所有数据。数据可以设置协作人，且可以对协作人指定是读写、只读权限': '私有：登录人数据权限不同，看到的数据范围不同，上级部门的部门负责人可以 看到下级部门的所有数据。数据可以设置协作人，且可以对协作人指定是读写、只读权限',
  '全员公开：数据再全员共享，与登录人的数据权限无关，租户内每个人都能看到这个对象下的所有数据': '全员公开：数据再全员共享，与登录人的数据权限无关，租户内每个人都能看到这个对象下的所有数据',
  '对象名称：': '对象名称：',
  '权限设置：': '权限设置：',
  保存: '保存',
  私有: '私有',
  全员公开: '全员公开'
};
